module.exports = __webpack_public_path__ + "static/assets/ffebd61396b0c891831469a2ed81d85a.svg";